import * as utils from './../libs/user-agent'
import Preload from '../libs/preload-it'

// Preloadをインスタンス化
const preload = new Preload()

// ローディング監視するファイルを追加する。 not で外部リソースを否定しないと、CORS制約で読み込みが停止する。
const $assets = document.querySelectorAll(
  '[src]:not([src*="unpkg.com"]):not([src*="youtube.com"]):not([src*="googletagmanager.com"]):not([src*="google-analytics.com"]):not([src*="player.vimeo.com"]):not([src*="infird.com"]):not(.wp-embedded-content), [rel="stylesheet"]'
)
const data = []
const DOM = {}
DOM.html = document.documentElement
DOM.loading = document.getElementById('js-loading')
DOM.bar = document.getElementById('js-bar')
DOM.num = document.getElementById('js-laoding-num')

Array.prototype.forEach.call($assets, $asset => {
  const url = $asset.src || $asset.href
  if (data.indexOf(url) == -1) {
    data.push($asset.src || $asset.href)
  }
})

preload.fetch(data)

preload.onprogress = event => {
  DOM.bar.style.width = event.progress + '%'
  DOM.num.textContent = event.progress + '%'
}

// 読み込み完了時のイベント
preload.oncomplete = () => {
  setTimeout(function () {
    DOM.html.classList.add('complete')
    DOM.loading.classList.add('is-complete')
  }, 500)
}
